import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import { Input } from "@repo/ui/components/Base/Input";
import { Button } from "@repo/ui/components/Base/Button";
import { AuthContext } from "@/providers";

const validationSchema = yup.object({
  email: yup
    .string()
    .email("Enter a valid email")
    .required("Email is required"),
  password: yup.string().required("Password is required"),
});

export const LogInForm = () => {
  const [, send] = AuthContext.useActor();
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      send({
        type: "SIGNIN",
        data: { ...values, setSubmitting: setSubmitting },
      });
    },
  });

  return (
    <div className="w-full md:w-96">
      <form onSubmit={formik.handleSubmit} className="gap-y-2 w-full">
        <Input
          id="email"
          name="email"
          label="Email"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.email && Boolean(formik.errors.email)}
          errorMessage={
            formik.touched.email && formik.errors.email
              ? formik.errors.email
              : ""
          }
        />
        <Input
          id="password"
          name="password"
          label="Password"
          type="password"
          value={formik.values.password}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.password && Boolean(formik.errors.password)}
          errorMessage={
            formik.touched.password && formik.errors.password
              ? formik.errors.password
              : ""
          }
        />
        <div className="flex flex-row justify-between mt-4">
          <Button
            variant="ghost"
            type="button"
            onClick={() => navigate("/auth/register")}
          >
            Sign Up
          </Button>

          <Button
            variant="ghost"
            type="button"
            onClick={() => navigate("/auth/resetPassword")}
          >
            Forgot Password?
          </Button>
        </div>
        <div className="mt-2">
          <Button
            variant="default"
            type="submit"
            className="w-full"
            disabled={formik.isSubmitting}
          >
            Login
          </Button>
        </div>
      </form>
    </div>
  );
};
